/* eslint-disable react/prop-types */
import React from "react";

const TYPE_COLOR = {
  materia_prima: "#457B9D",
  semilavorato: "#1D3557",
  prodotto_finito: "#2A9D8F",
  imballaggio: "#F4A261",
};

const TYPE_LABEL = {
  materia_prima: "MP",
  semilavorato: "SL",
  prodotto_finito: "PF",
  imballaggio: "IMB",
};

function renderNode(node, depth) {
  const pad = depth * 20;
  const kids = node.children || [];
  return React.createElement(
    "div",
    { key: `${node.product_id}-${depth}` },
    React.createElement(
      "div",
      {
        className: "flex items-center gap-2 py-1.5",
        style: { paddingLeft: pad },
      },
      React.createElement(
        "span",
        { className: "text-[#9CA3AF] font-mono-data text-xs select-none" },
        "\u2514\u2500"
      ),
      React.createElement(
        "span",
        {
          className:
            "inline-block px-2 py-0.5 text-[10px] font-mono-data font-semibold text-white",
          style: { background: TYPE_COLOR[node.product_type] },
        },
        TYPE_LABEL[node.product_type]
      ),
      React.createElement(
        "span",
        { className: "text-sm text-[#0A0A0A]" },
        node.product_name
      ),
      node.product_barcode &&
        React.createElement(
          "span",
          { className: "font-mono-data text-[10px] text-[#4B5563]" },
          node.product_barcode
        ),
      React.createElement(
        "span",
        { className: "ml-auto font-mono-data text-sm font-semibold text-[#0A0A0A]" },
        `${node.required_quantity.toFixed(3)} ${node.unit}`
      )
    ),
    kids.length > 0 &&
      React.createElement(
        "div",
        null,
        kids.map((c, i) => renderNode({ ...c, _idx: i }, depth + 1))
      )
  );
}

export default function DistintaTree({ rootName, rootType, rootQuantity, rootUnit, tree }) {
  return React.createElement(
    "div",
    null,
    React.createElement(
      "div",
      {
        className: "flex items-center gap-2 py-1.5 border-b border-[#E5E7EB] mb-2 pb-2",
      },
      React.createElement(
        "span",
        {
          className:
            "inline-block px-2 py-0.5 text-[10px] font-mono-data font-semibold text-white",
          style: { background: TYPE_COLOR[rootType] },
        },
        TYPE_LABEL[rootType]
      ),
      React.createElement(
        "span",
        { className: "text-sm font-display font-bold text-[#0A0A0A]" },
        rootName
      ),
      React.createElement(
        "span",
        { className: "ml-auto font-mono-data text-sm font-semibold text-[#0A0A0A]" },
        `${rootQuantity.toFixed(3)} ${rootUnit}`
      )
    ),
    tree.map((c, i) => renderNode({ ...c, _idx: i }, 1))
  );
}
